import { render, staticRenderFns } from "./employee-identity.vue?vue&type=template&id=77463ae8&"
import script from "./employee-identity.vue?vue&type=script&lang=js&"
export * from "./employee-identity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports